{
  "cecilia": {
    "chapel": {
      "id": "northwest-chapel",
      "u": -17.7,
      "v": 30.8,
      "angleDeg": 0,
      "length": 24,
      "width": 9.2,
      "eaves": 10.1,
      "ridge": 15.3,
      "floors": 1,
      "bays": 5,
      "roof": "slate",
      "passage": 0
    },
    "belfry": {
      "u": -5,
      "radius": 0.65,
      "foot": 14.8,
      "eaves": 17.3,
      "tip": 20.4
    },
    "ranges": [
      {
        "id": "voorburgwal-main-body",
        "u": -30.7,
        "v": 6.4,
        "angleDeg": 81.2,
        "length": 38,
        "width": 8.7,
        "eaves": 8.4,
        "ridge": 13.2,
        "floors": 2,
        "bays": 9,
        "roof": "slate",
        "passage": 2.8
      },
      {
        "id": "achterburgwal-range",
        "u": 14,
        "v": 5,
        "angleDeg": 82.3,
        "length": 45,
        "width": 10.5,
        "eaves": 6.8,
        "ridge": 12.1,
        "floors": 2,
        "bays": 11,
        "roof": "slate",
        "passage": 0
      },
      {
        "id": "south-work-range",
        "u": -11.35,
        "v": -15,
        "angleDeg": 0,
        "length": 33.3,
        "width": 6,
        "eaves": 4.2,
        "ridge": 7.4,
        "floors": 1,
        "bays": 8,
        "roof": "tile",
        "passage": 0
      }
    ],
    "court": [
      [-30, -11],
      [5, -11],
      [11, 24],
      [-22, 24]
    ],
    "garden": {
      "u0": -18,
      "u1": 3,
      "v0": -4,
      "v1": 13,
      "rows": 3,
      "columns": 2
    },
    "entryRange": "voorburgwal-main-body",
    "note": "The northwest chapel, Voorburgwal main body, low work buildings and open planted court follow the painting, woodcut and Pierik reconstruction. Only the 10.5 m width of the investigated Achterburgwal range comes from the 1990 excavation; its length is unknown. All other fitted dimensions, roof coverings, storeys, belfry, window rhythm, beds and main-body passage are estimates. Six beds are a provisional garden arrangement, not a surveyed 1538 planting plan. The RCE dates the surviving turret to the early 17th century; this small pointed belfry follows the period silhouettes instead."
  },
  "catharina": {
    "chapel": {
      "id": "cross-plot-chapel",
      "u": -12,
      "v": -26.5,
      "angleDeg": 0,
      "length": 34,
      "width": 9,
      "eaves": 10.4,
      "ridge": 16,
      "floors": 1,
      "bays": 7,
      "roof": "slate",
      "passage": 0
    },
    "belfry": {
      "u": 6,
      "radius": 0.6,
      "foot": 15.5,
      "eaves": 17.5,
      "tip": 20.2
    },
    "ranges": [
      {
        "id": "voorburgwal-range",
        "u": -34.3,
        "v": -45,
        "angleDeg": 90,
        "length": 27,
        "width": 6.5,
        "eaves": 4.8,
        "ridge": 8.3,
        "floors": 1,
        "bays": 7,
        "roof": "tile",
        "passage": 2.8
      },
      {
        "id": "achterburgwal-range",
        "u": 7.7,
        "v": -47.5,
        "angleDeg": 82.3,
        "length": 39,
        "width": 7.1,
        "eaves": 7.2,
        "ridge": 11.6,
        "floors": 2,
        "bays": 9,
        "roof": "slate",
        "passage": 0
      },
      {
        "id": "south-rear-body",
        "u": -16,
        "v": -63.2,
        "angleDeg": 0,
        "length": 34,
        "width": 6.5,
        "eaves": 7.3,
        "ridge": 11.4,
        "floors": 2,
        "bays": 8,
        "roof": "slate",
        "passage": 0
      }
    ],
    "court": [
      [-30.8, -58.7],
      [0, -58.7],
      [4.8, -32.2],
      [-30.8, -32.2]
    ],
    "garden": {
      "u0": -23,
      "u1": -7,
      "v0": -53,
      "v1": -38,
      "rows": 1,
      "columns": 1
    },
    "entryRange": "voorburgwal-range",
    "note": "Catharina is the distinct institution between Cecilia and Agnieten, documented by the Prinsenhof excavation, RCE and Religieus Erfgoed Amsterdam. The painting and 1544 woodcut guide the cross-plot chapel, unequal side/rear bodies and open court; the misleading woodcut Margriet label does not create a second Nes convent here. Only the 7.1 m width of the investigated Achterburgwal range is measured in the 1990 report. Its length and all other fitted dimensions, elevations, roof coverings, window openings, belfry and plain west passage remain estimates."
  }
}
